export default "__VITE_ASSET__DIQGnL5C__"